export default {
  profile: {},

  roles: [],
  role: {},
  roleCode: null,

  rolePermissions: [],

  userRoles: [],
  defaultRole: null,
  defaultPermissions: [],
  reloadNavbar: true,

  users: [],
  user: {},

  persons: [],
  personByMobile: {},
  personByNationalCode: {},
};
